import React from "react";

interface TableColumn {
  key: string;
  label: string;
  align?: "left" | "right" | "center";
}

interface TableRow {
  [key: string]: React.ReactNode;
}

interface TableProps {
  columns: TableColumn[];
  rows: TableRow[];
  className?: string;
  showHeader?: boolean;
}

export const Table: React.FC<TableProps> = ({
  columns,
  rows,
  className = "",
  showHeader = true
}) => {
  return (
    <div className={`ob-table ${className}`}>
      <table>
        {showHeader && (
          <thead>
            <tr>
              {columns.map((column) => (
                <th
                  key={column.key}
                  style={{ textAlign: column.align || "left" }}
                >
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              {columns.map((column) => (
                <td
                  key={column.key}
                  style={{ textAlign: column.align || "left" }}
                >
                  {row[column.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
